import * as actionTypes from '../store/actions/ActionTypes';
import Config from '../utils/Configuration';
import Utility from '../utils/Helper';

const createActionCreator = (type) => {
    return (payload, meta) => {
        const action = {type};
        if (typeof payload !== 'undefined') {
            action.payload = payload;
        }
        if (payload instanceof Error) {
            action.error = true;
        }
        if (typeof meta !== 'undefined') {
            action.meta = meta;
        }
        return action;
    };
};

const dispatchStoreAction = (type, payload, dispatch) => {
    const action = createActionCreator(type);
    dispatch(action(payload));
};

const serviceRequest = async (
    options,
    dispatch,
    serviceMethod,
    payload,
    actionType = actionTypes.NO_ACTION,
    getSuccessPayload = (res) => {
        return res.data;
    },
    getErrorPayload = (err) => {
        return err;
    }
) => {
    try {
        if (!options || !options.skipLoader) {
            dispatch({
                type: actionTypes.START_LOADING
            });
        }
        const res = await serviceMethod(payload);
        if (typeof dispatch === 'function' && (!options || !options.skipErrorHandling)) {
            if (Utility.getValues(res, 'data.status', '') === Config.apiStatus.fail) {
                const globalMessage = [];
                res.data.violations.length > 0 &&
                    res.data.violations.forEach((messageItem) => globalMessage.push({...messageItem, actionType}));
                dispatchStoreAction(
                    actionTypes.SET_MS_MESSAGE,
                    {
                        type: 'ERROR',
                        globalMessage
                    },
                    dispatch
                );
            } else {
                dispatchStoreAction(actionTypes.CLEAR_MS_MESSAGE, {actionType}, dispatch);
            }
        }
        const serviceRequestResponse = await Promise.resolve(getSuccessPayload(res));
        if (typeof dispatch === 'function' && actionType) {
            dispatchStoreAction(actionType, serviceRequestResponse, dispatch);
        }
        return serviceRequestResponse;
    } catch (err) {
        const serviceRequestErr = await Promise.resolve(getErrorPayload(err));
        if (typeof dispatch === 'function' && (!options || !options.skipErrorHandling)) {
            dispatchStoreAction(
                actionTypes.SET_MESSAGE,
                {code: '999', message: 'Something went wrong, please refresh the page and try again.'},
                dispatch
            );
        }
        if (typeof dispatch === 'function' && actionType) {
            dispatchStoreAction(actionType, serviceRequestErr, dispatch);
        }
        throw serviceRequestErr;
    } finally {
        if (!options || !options.skipLoader) {
            dispatch({
                type: actionTypes.FINISH_LOADING
            });
        }
    }
};

const baseService = {serviceRequest, dispatchStoreAction};

export default baseService;
